import ANNUAL_EVENT_2017 from "../resources/images/AnnualEvent_2017.webp";
import ANNUAL_FAMILY from "../resources/images/Annual_Family.webp";
import CRICKET_TOURNAMENT from "../resources/images/cricket_tournament.webp";
import EMPTY_IMAGE from "../resources/images/emptyPicture.png";
import EVENT_2023 from "../resources/images/business_meet_2023.webp";
import EVENT_2024 from "../resources/images/business_meet_2024.webp";
import MPL_EVENT from "../resources/images/mpl_tournament.jpeg";

export const userList = [
    {
        username: "Abhishek Singh",
        description: "Looking for a job",
        mobile: "8697192318",
        dob: "02/09/1997"
    },
    {
        username: "Mayukh Sasmal",
        description: "For marriage",
        mobile: "9192719231",
        dob: "16/06/1983"
    },
    {
        username: "Rakesh Verma",
        description: "To join Sanstha",
        mobile: "8635192318",
        dob: "15/03/1976"
    },
    {
        username: "Rupesh Kudale",
        description: "For business opportunities",
        mobile: "7007192318",
        dob: "02/11/1994"
    },
];

export const UpcomingEventList = [
    {
        title: "Coming Soon..",
        date: "",
        location: "",
        mode: "",
        image: EMPTY_IMAGE,
    },
    {
        title: "Coming Soon..",
        date: "",
        location: "",
        mode: "",
        image: EMPTY_IMAGE,
    },
    {
        title: "Coming Soon..",
        date: "",
        location: "",
        mode: "",
        image: EMPTY_IMAGE,
    }
];

export const RecentEvents = [
    {
        title: "Maurya Premier League",
        date: "05/10/2025",
        location: "V4 Sports Arena Khandelwal Compound, Near CEAT Company, Ushanagar, Nahur, Mumbai-78",
        mode: "In Person",
        image: MPL_EVENT,
    },
    {
        title: "Annual Family & Friendship Conference & Youth Introduction Summit",
        date: "25/12/2024",
        location: "Vedanta Open Theatre Ground, Near Dosti Vihar, Corus Road, Vartak Angar, Thane(West)",
        mode: "In Person",
        image: ANNUAL_FAMILY,
    },
    {
        title: "Maurya Business Summit - 2024",
        date: "11/08/2024",
        location: "DE Grandeur Hotels & Banquets, Royal Plaza Anand Nagar, Bhakti Park Ghodbunder Road, Thane (West)",
        mode: "In Person",
        image: EVENT_2024,
    },
    {
        title: "Annual Family & Friendship Conference & Youth Introduction Summit",
        date: "07/01/2024",
        location: "Vedanta Open Theatre Ground, Near Dosti Vihar, Corus Road, Vartak Angar, Thane(West)",
        mode: "In Person",
        image: ANNUAL_FAMILY,
    },
    {
        title: "Cricket Tournament - 2023",
        date: "02/10/2023",
        location: "",
        mode: "In Person",
        image: CRICKET_TOURNAMENT,
    },
    {
        title: "Maurya Business Summit - 2023",
        date: "09/04/2023",
        location: "DE Grandeur Hotels & Banquets, Royal Plaza Anand Nagar, Bhakti Park Ghodbunder Road, Thane (West)",
        mode: "In Person",
        image: EVENT_2023,
    },
    {
        title: "Annual Family & Friendship Conference & Youth Introduction Summit",
        date: "24/12/2017",
        location: "Vedanta Open Theatre Ground, Near Dosti Vihar, Corus Road, Vartak Angar, Thane(West)",
        mode: "In Person",
        image: ANNUAL_EVENT_2017,
    },
    {
        title: "Annual Family & Friendship Conference & Youth Introduction Summit",
        date: "07/03/2015",
        location: "Vedanta Open Theatre Ground, Near Dosti Vihar, Corus Road, Vartak Angar, Thane(West)",
        mode: "In Person",
        image: ANNUAL_FAMILY,
    },
];